import type { PortalEditBody } from '../../../lib/api';

/**
 * VP9 - what the editor's forms share. Every form saves through the container, which adds the portal's version
 * (`expectedUpdatedAt`) and answers null when the change was saved, or the server's reasons - word for word - when
 * it was refused.
 */
export type SaveChange = (body: Omit<PortalEditBody, 'expectedUpdatedAt'>) => Promise<string[] | null>;

/** Today in the reader's own time zone, as the YYYY-MM-DD a date input holds. */
export const todayIso = (): string => {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const FIELD = 'mt-1 w-full px-3 py-2 border border-gray-300 rounded-lg text-sm text-gray-900 bg-white';
export const LABEL = 'block text-xs text-gray-500';
export const PRIMARY = 'px-4 py-2 bg-primary-500 text-white text-sm font-medium rounded-lg hover:bg-red-700 disabled:opacity-50';
export const QUIET = 'px-3 py-1.5 border border-gray-300 text-xs rounded-lg hover:bg-gray-50 disabled:opacity-50';

/** The server's reasons, each on its own line, under the form that caused them. */
export function Refusals({ errors }: { errors: string[] }) {
  if (!errors.length) return null;
  return (
    <ul className="mt-2 space-y-1 text-sm text-red-700" aria-live="polite">
      {errors.map((e) => (
        <li key={e}>{e}</li>
      ))}
    </ul>
  );
}
